/** Register the PWA shell only in production. Device/HID code stays independent. */
export function registerPwa(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(registration => {
      // Check again when connectivity returns so a deployed SW is picked up
      // without waiting for the browser's periodic update check.
      window.addEventListener('online', () => {
        void registration.update().catch(error => {
          console.warn('[PWA] Service worker update failed:', error)
        })
      })
    }).catch(error => {
      console.warn('[PWA] Service worker registration failed:', error)
    })
  }, { once: true })
}
